import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <section className="mx-auto max-w-2xl px-4 py-24 text-center">
      <XCircle size={64} className="mx-auto text-white/50"/>
      <h1 className="mt-6 font-display text-4xl uppercase">Pagamento annullato</h1>
      <p className="mt-3 text-white/70">Nessun addebito effettuato.</p>
      <Link to="/" className="brutal-btn brutal-btn-outline mt-8 inline-flex">Torna alla home</Link>
    </section>
  );
}
